const defaultState = {
  loadingButton: false,
  homeBannerDismissed: false,
  setupScheduleDismissed: false,
  verifyProfileDismissed: { profile: false, home: false },
  postData: null,
  errRes: {},
  barStyle: 'dark-content',
  startingConnectId: null,
  activeConnect: null,
  loggedInOnce: false,
  showNotifications: false,
  tabBarHt: 0,
  darkMode: false,
  showGetApp: false,
  signupCode: null,
  language: 'en',
  // True once the user explicitly picks a language from the in-app
  // dropdown. While false, the app re-detects the system/browser
  // language on every visit (per-device, never synced cross-device).
  languageManuallySet: false,
  // `<account id>:<language>` last saved to the account, so emails use the fan's choice. See
  // containers/saveLanguageChoice.js.
  languageSavedToAccount: null,
  addingShoutout: {
    type: 0,
    comment: '',
    selectedType: 'Athletes',
    media: [],
    eventId: '',
    player: null
  },
  rates: {},
  deviceInfo: {},
  pinchedPost: {
    isPinchingPost: false,
    id: null
  }
};

const appState = (state = defaultState, action) => {
  const { payload, type } = action;

  switch (type) {
    case 'SET_RESULTS':
      return {
        ...defaultState,
        loggedInOnce: state.loggedInOnce,
        signupCode: state.signupCode,
        language: state.language,
        languageManuallySet: state.languageManuallySet,
        isZoomed: state?.isZoomed,
        deviceInfo: state.deviceInfo,
        // active CTA flow (social signups skip onboarding) must survive reloads,
        // or the Onboarding gate in User.js fires on any non-flow route
        ctaFlowPath: state.ctaFlowPath
      };

    case 'LOADING_BUTTON':
      return {
        ...state,
        loadingButton: payload
      };

    case 'UPDATE_POST_DATA':
      return {
        ...state,
        postData: payload
      };

    case 'UPDATE_SHOUTOUT_DATA':
      return {
        ...state,
        addingShoutout: payload
      };

    case 'RESET_SHOUTOUT_DATA':
      return {
        ...state,
        addingShoutout: {
          type: 0,
          comment: '',
          selectedType: 'Athletes',
          media: [],
          eventId: '',
          player: null
        }
      };

    case 'UPDATE_APP_STATE':
      return {
        ...state,
        ...payload
      };

    case 'UPDATE_BAR_STYLE':
      return {
        ...state,
        barStyle: payload
      };

    case 'START_CONNECT':
      return {
        ...state,
        activeConnect: payload
      };

    case 'CONNECT_STARTING':
      return {
        ...state,
        startingConnectId: payload._id
      };

    case 'UPDATE_DEVICE_INFO':
      return {
        ...state,
        deviceInfo: {
          ...(state?.deviceInfo || {}),
          payload
        }
      };

    case 'HANDLE_RES':
      return {
        ...state,
        errRes: {
          err: payload?.err ? payload.err : null,
          res: payload?.res ? payload.res : null
        }
      };

    case 'RESET_LIVE_STREAM_STATE':
      return {
        ...state,
        isLive: false
      };

    case 'LOGOUT':
      return {
        ...defaultState,
        language: state.language,
        languageManuallySet: state.languageManuallySet,
        isZoomed: state?.isZoomed
      };

    case 'SET_PINCHING_POST':
      return {
        ...state,
        pinchedPost: {
          isPinchingPost: true,
          id: payload?.postId
        }
      };

    case 'RESET_PINCHING_POST':
      return {
        ...state,
        pinchedPost: {
          isPinchingPost: false,
          id: null
        }
      };

    default:
      return { ...state, language: state.language };
  }
};

export default appState;
